// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface IsolationUnitSpecInput
 */
export interface IsolationUnitSpecInput {
  /**
   *
   * @type {string}
   * @memberof IsolationUnitSpecInput
   */
  cloudProvider?: string;
  /**
   *
   * @type {string}
   * @memberof IsolationUnitSpecInput
   */
  tenancy?: string;
}

/**
 * Check if a given object implements the IsolationUnitSpecInput interface.
 */
export function instanceOfIsolationUnitSpecInput(
  value: object,
): value is IsolationUnitSpecInput {
  return true;
}

export function IsolationUnitSpecInputFromJSON(
  json: any,
): IsolationUnitSpecInput {
  return IsolationUnitSpecInputFromJSONTyped(json, false);
}

export function IsolationUnitSpecInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IsolationUnitSpecInput {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    tenancy: json['tenancy'] == null ? undefined : json['tenancy'],
  };
}

export function IsolationUnitSpecInputToJSON(
  json: any,
): IsolationUnitSpecInput {
  return IsolationUnitSpecInputToJSONTyped(json, false);
}

export function IsolationUnitSpecInputToJSONTyped(
  value?: IsolationUnitSpecInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: value['cloudProvider'],
    tenancy: value['tenancy'],
  };
}
